import { render, staticRenderFns } from "./TranslationDialog.vue?vue&type=template&id=df01b212&scoped=true"
import script from "./TranslationDialog.vue?vue&type=script&lang=js"
export * from "./TranslationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df01b212",
  null
  
)

export default component.exports